// Require needed libs.

// Export component settings.
export const settings = {
  componentClassName: 'js-slide-nav',
  componentCssSelector: '.js-slide-nav',
  toggleCssSelector: '.js-slide-nav-toggle',
  activeClassName: 'state--active',
  navOpen: false,
  side: null,
  pushModeOn: false,
  toggle: null,
  id: null
}

/**
 * Initialize the component.
 *
 * @param {DOMNode} nav
 */
export function init( nav ) {
  // Clone the default settings.
  let ownSettings = Object.assign({}, settings )
  // Customize the settings.
  ownSettings.id = nav.getAttribute( 'id' )
  ownSettings.side = nav.getAttribute( 'data-menu-direction' )
  ownSettings.pushModeOn = Boolean( nav.getAttribute( 'data-menu-push' ))
  ownSettings.toggle = document.querySelector( ownSettings.toggleCssSelector + '#' + ownSettings.id )
  ownSettings.globalActiveClassName = `${ownSettings.id}-slide-nav--active`
  ownSettings.sideActiveClassName = `${ownSettings.id}-slide-nav-${ownSettings.side}--active`
  ownSettings.globalNavModeClassName = `${ownSettings.id}-slide-nav-${ownSettings.side}-push--${ownSettings.pushModeOn}`

  // Toggle the menu open state.
  ownSettings.toggle.addEventListener( 'click', function() {
    toggleNav( nav, ownSettings )
  })

  initNavAccordion( nav )

  /**
   * Close menu if clicked outside of it when it's open.
   */
  document.body.addEventListener( 'click', ( e ) => {
    if (
      ( ownSettings.navOpen && ( nav.contains( e.target ) && e.target.tagName === 'A' )) || // It's a child of nav and it's a link
      ( ownSettings.navOpen &&
      !nav.contains( e.target ) && // It's not a decendant of the nav
      e.target !== nav && // It's not the nav
      !ownSettings.toggle.contains( e.target ) && // It's not a decendant of the toggle
      e.target !== ownSettings.toggle ) // It's not the toggle
    ) {
      closeNav( nav, ownSettings )
    }
  })
}

/**
 * Fetches the elements from DOM on it's own and initializes them.
 */
export default function lateInitAll() {
  let elements = document.querySelectorAll( settings.componentCssSelector )
  Array.from( elements ).forEach(( element ) => {
    init( element )
  })
}

/**
 * Initialize possible accordions inside the nav.
 *
 * @param {DOMNode} nav
 */
 function initNavAccordion( nav ) {
  const accordionElements = Array.from( nav.querySelectorAll( '.menu-item-has-children' ))

  accordionElements.forEach(( accordionEl ) => {
    // const content = accordionEl.querySelector( '.sub-menu' )
    const link = accordionEl.querySelector( 'a' )
    const toggle = document.createElement( 'button' )

    // Create toggle button for sub-menu
    toggle.classList.add( 'js-accordion--toggle', 'c-slide-nav__accordion-toggle' )
    toggle.setAttribute( 'aria-label', 'Open sub navigation' )
    toggle.addEventListener( 'click', function() {
      // toggleSubMenu( this, content )
      accordionEl.querySelector( '.sub-menu' ).classList.toggle( 'active' )
      toggle.classList.toggle( 'js-accordion--open' )
    })
    accordionEl.insertBefore( toggle, link )
  })
}

/**
 * Toggle the navigation state.
 *
 * @param {DOMNode} nav
 * @param {object} ownSettings
 */
const toggleNav = function( nav, ownSettings ) {
  if ( ownSettings.navOpen ) {
    closeNav( nav, ownSettings )
  } else {
    openNav( nav, ownSettings )
  }
}

/**
 * Open the navigation.
 *
 * @param {DOMNode} nav
 * @param {object} ownSettings
 */
const openNav = function( nav, ownSettings ) {
  // Add classes to body that control hiding/revealing the navs.
  document.body.classList.add( ownSettings.globalActiveClassName )
  document.body.classList.add( ownSettings.sideActiveClassName )
  document.body.classList.add( ownSettings.globalNavModeClassName )

  // Add open state class to nav. This is just for extre styling.
  nav.classList.add( ownSettings.activeClassName )

  // Add open state class to toggle. This is just for extre styling.
  ownSettings.toggle.classList.add( ownSettings.activeClassName )

  // Update the nav state.
  ownSettings.navOpen = true
}

/**
 * Close the navigation.
 *
 * @param {DOMNode} nav
 * @param {object} ownSettings
 */
const closeNav = function( nav, ownSettings ) {
  // Remove classes from body that control hiding/revealing the navs.
  document.body.classList.remove( ownSettings.globalActiveClassName )
  document.body.classList.remove( ownSettings.sideActiveClassName )
  document.body.classList.remove( ownSettings.globalNavModeClassName )

  // Remove open state class from nav. This is just for extre styling.
  nav.classList.remove( ownSettings.activeClassName )

  // Remove open state class from toggle. This is just for extre styling.
  ownSettings.toggle.classList.remove( ownSettings.activeClassName )

  // Update the nav state.
  ownSettings.navOpen = false
}
